define('lib/view/LayoutView',['require','marionette','lib/view/UnwrapBehavior'],function (require) {

    var Marionette = require('marionette');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Layout view without wrap
     *
     * @class LayoutView
     */
    return Marionette.LayoutView.extend({

        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },
        
        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        }

    });

});


